import React from 'react'
import { registerUser } from '../apis/accountRequests'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { notificationActions } from '../actions/notificationActions'
import { userSchema } from '../validation/userSchema'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Grid, Button, Typography, Divider } from '@mui/material'
import { FormTextField } from '../controls'
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const fields = userSchema.describe().fields

const errorPassword = ["PasswordTooShort", "PasswordRequiresNonAlphanumeric", "PasswordRequiresLower", "PasswordRequiresUpper"]

export default function AccountRegister() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(userSchema),
        reValidateMode: 'onBlur',
    })

    const onSubmit = data => {
        data.roles = ['Usuario']

        registerUser(data)
            .then(res => {
                dispatch(notificationActions.showSuccess({ message: `Se ha creado con éxito el usuario` }))
                navigate('/login')
            })
            .catch(err => {
                err.response.data.errors.some(r => errorPassword.includes(r.code)) ?
                    dispatch(notificationActions.showError({ message: 'la contraseña no cumple con los requisitos' })) :
                    dispatch(notificationActions.showError({ message: 'Ha ocurrido un error al crear el usuario' }))
            })
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Button
                size="small"
                variant="outlined"
                style={{
                    color: "black",
                    backgroundColor: "#B5CD7F",
                    borderColor: "#B5CD7F",
                    '&:hover':{
                        backgroundColor:"#8BB85A",
                    }
                }}
                startIcon={<ChevronLeftIcon />}
                onClick={() => {
                    navigate("/cart");
                }}
            >
                Volver a login
            </Button>
            <Typography variant='h5' align='center' gutterBottom>Nuevo Cliente</Typography>
            <Divider style={{ marginBottom: '1em' }} />
            <Grid container direction='row' justifyContent='center' alignItems='stretch' spacing={1}>
                <Grid item xs={5}>
                    <FormTextField size='small' name='dynamicsId' style={{ width: "100%" }}
                        control={control} schema={fields.dynamicsId} formErrors={errors.dynamicsId} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='userName' style={{ width: "100%" }}
                        control={control} schema={fields.userName} formErrors={errors.userName} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='fullName' style={{ width: "100%" }}
                        control={control} schema={fields.fullName} formErrors={errors.fullName} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='email' style={{ width: "100%" }}
                        control={control} schema={fields.email} formErrors={errors.email} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='phoneNumber' style={{ width: "100%" }}
                        control={control} schema={fields.phoneNumber} formErrors={errors.phoneNumber} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='address' style={{ width: "100%" }}
                        control={control} schema={fields.address} formErrors={errors.address} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='city' style={{ width: "100%" }}
                        control={control} schema={fields.city} formErrors={errors.city} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='state' style={{ width: "100%" }}
                        control={control} schema={fields.state} formErrors={errors.state} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='country' style={{ width: "100%" }}
                        control={control} schema={fields.country} formErrors={errors.country} />
                </Grid>
                <Grid item xs={5} />
                <Grid item xs={10}>
                    <Typography variant='h6' align='center' gutterBottom>Contraseña</Typography>
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='password' type='password' style={{ width: "100%" }}
                        control={control} schema={fields.password} formErrors={errors.password} />
                </Grid>
                <Grid item xs={5}>
                    <FormTextField size='small' name='passwordConfirm' type='password' style={{ width: "100%" }}
                        control={control} schema={fields.passwordConfirm} formErrors={errors.passwordConfirm} />
                </Grid>
                <Typography variant='caption' align='center'><br />
                    Utiliza 6 caracteres como mínimo,incluyendo una letra mayúscula, minúscula y un carácter no alfanumérico.
                </Typography>
                <Grid item xs={12} style={{ paddingBottom: 2 }}>
                    <Button fullWidth type='submit' style={{
                        color: "black",
                        backgroundColor: "#B5CD7F"
                    }}>
                        Confirmar
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}